import { useEffect, useMemo } from "react";
import { v2SaleContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";
import useSnackbarRpcSuccess from "hooks/useSnackbarRpcSuccess";
import { BigNumber } from "ethers";

const useV2Mint = (
  value?: BigNumber,
  referenceTokenIds?: number[],
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, mint] =
    useContractWrite(
      {
        addressOrName: v2SaleContract.address,
        contractInterface: v2SaleContract.interface,
      },
      "mint",
      {
        args: [referenceTokenIds],
        overrides: {
          value,
        },
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);
  useSnackbarRpcSuccess(waitData);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData && onSuccess) {
      onSuccess();
    }
  }, [isWaiting, waitData, onSuccess]);

  return useMemo(
    () => [mint, isLoading || isWaiting],
    [mint, isWaiting, isLoading]
  );
};

export default useV2Mint;
